export default __webpack_public_path__ + "static/media/mobile-img.4e956f43.png";